/* Atlas home "New in" tabs and product carousel arrows, ported from ac-cat-v2 home-new-in.js. */
(function () {
  function init(root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
    var cur = 0;
    function active() { return panels[cur]; }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        cur = parseInt(t.getAttribute('data-tab'), 10) || 0;
        tabs.forEach(function (x, i) { x.classList.toggle('is-on', i === cur); x.setAttribute('aria-selected', i === cur ? 'true' : 'false'); });
        panels.forEach(function (p, i) { p.hidden = i !== cur; });
        if (active()) active().scrollTo({ left: 0, behavior: 'smooth' });
        place();
      });
    });
    var rail = root.querySelector('.home-newin__rail');
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    /* scroll by the whole cards that fit, so the next card lands where the first one was */
    function by(d) {
      var el = active(); if (!el) return;
      var c = el.firstElementChild;
      var step = c ? c.getBoundingClientRect().width + 12 : 300;
      var fit = Math.max(1, Math.floor((el.clientWidth - 40 + 12) / step));
      el.scrollBy({ left: d * step * fit, behavior: 'smooth' });
    }
    /* hide an arrow when there is nothing more that way */
    function ends() {
      var el = active(); if (!el || !p || !n) return;
      var max = el.scrollWidth - el.clientWidth;
      p.classList.toggle('is-off', el.scrollLeft <= 4);
      n.classList.toggle('is-off', el.scrollLeft >= max - 4);
    }
    /* level the arrows with the middle of the photos */
    function place() {
      var el = active(); if (!el || !rail) return;
      var m = el.querySelector('.home-card__media, .plpb-card__media, img');
      if (m) rail.style.setProperty('--ni-mid', (m.getBoundingClientRect().top - rail.getBoundingClientRect().top + m.offsetHeight / 2) + 'px');
      ends();
    }
    if (p) p.addEventListener('click', function () { by(-1); });
    if (n) n.addEventListener('click', function () { by(1); });
    panels.forEach(function (el) { el.addEventListener('scroll', ends, { passive: true }); });
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    place();
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-home-newin]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
